const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;

export function isValidHexColor(value: unknown): value is string {
  return typeof value === "string" && HEX_COLOR_RE.test(value);
}

export function normalizeHexColor(hex: string): string {
  if (!isValidHexColor(hex)) throw new Error(`Invalid hex color "${hex}". Expected #RRGGBB.`);
  return hex.toUpperCase();
}

export function rgbToHex(r: number, g: number, b: number): string {
  return `#${[r, g, b].map((channel) => Math.max(0, Math.min(255, channel)).toString(16).padStart(2, "0")).join("")}`.toUpperCase();
}
